import store from '@/store';
import {checkServerState} from '@/utils/healthCheck.js';
import {resolveApiErrorMessage} from '@/errors/resolveApiErrorMessage.js';

const FYGR_ACCESS_TOKEN = 'FYGR_ACCESS_TOKEN';
const FYGR_OAUTH_ACCESS_TOKEN = 'FYGR_OAUTH_ACCESS_TOKEN';
const FYGR_PRETENDED_USER = 'FYGR_PRETENDED_USER';
// const urlBase = process.env.VUE_APP_ENV === 'dev' ?
// `${process.env.VUE_APP_API}/api/v2` : '/api/v2';
// const urlOauthBase = process.env.VUE_APP_ENV === 'dev'
// ? `${process.env.VUE_APP_API}/oauth2/pkce` : '/oauth2/pkce';
const urlBase = `${import.meta.env.VITE_APP_API}/v2`;
const urlOauthBase = `${import.meta.env.VITE_APP_API}/oauth2/pkce`;
const objectToParamString = (obj) =>
  `${Object.entries(obj)
    .map((p, v) => `${p}=${v}`)
    .join('&')}`;

// const objectToParamString = (obj) => //this one should do the job if needed GET
//   `?${Object.keys(obj)
//     .map((p, v) => `${p}=${obj[p]}`)
//     .join('&')}`;

const NoResponseAPI = {
  error: true,
  message: "Une erreur s'est produite. Veuillez réessayer ultérieurement",
  result: null,
  network: true,
};

export const callDummy = async () =>
  new Promise((r) => setTimeout(() => r({}), 2000));

export const callAPI = (
  method,
  api,
  data = {},
  useMainToken = false,
  timeout = 20,
  recall = 0,
  immediate = false,
  signal = undefined,
  header,
) => {
  let timer = null;
  return Promise.race([
    new Promise((resolve) => {
      if (timeout) {
        timer = setTimeout(async () => {
          let response = {error: 'Timeout'};
          if (recall < 1) {
            response = await callAPI(
              method,
              api,
              data,
              useMainToken,
              timeout,
              recall + 1,
            );
          }
          setTimeout(() => resolve(response));
        }, timeout * 1000);
      }
    }),
    new Promise((resolve, reject) => {
      const isFormData =
        typeof FormData !== 'undefined' && data instanceof FormData;
      const headers = {};
      if (!isFormData) {
        headers['Content-Type'] = 'application/json; charset=utf-8';
        // 'ngrok-skip-browser-warning': 'true',  FOR NGROK usage uncomment headers
      }
      let pretendedUser = null;
      try {
        pretendedUser = JSON.parse(localStorage.getItem(FYGR_PRETENDED_USER));
      } catch {} // eslint-disable-line
      if (useMainToken || !pretendedUser) {
        const token = localStorage.getItem(FYGR_ACCESS_TOKEN);
        headers.Authorization = token ? `Bearer ${token}` : '';
      } else {
        headers.Authorization = pretendedUser.token
          ? `Bearer ${pretendedUser.token}`
          : '';
        if (
          api === 'downloadTransactions' ||
          api === 'downloadInvoices' ||
          api === 'exportDashboardXLSX' ||
          api === 'exportDashboardConsolidationTableXLSX'
        ) {
          const token = localStorage.getItem(FYGR_ACCESS_TOKEN);
          headers['X-Auth-Token'] = token || null;
        }
      }
      fetch(
        `${urlBase}/${api}${method === 'GET' ? objectToParamString(data) : ''}`,
        {
          method,
          signal,
          mode: 'cors',
          cache: 'no-cache',
          credentials: 'same-origin',
          headers: {...headers, ...header},
          redirect: 'follow',
          referrer: 'no-referrer',
          body:
            method === 'GET'
              ? null
              : isFormData
                ? data
                : JSON.stringify(data),
        },
      )
        .then((response) => {
          clearTimeout(timer);
          if (immediate) {
            resolve(response);
            return;
          }
          response
            .json()
            .then((d) => {
              if (response.status === 401) {
                if (d?.error_message === 'Token has expired') {
                  store.commit('user/setSigninPopup', true, {
                    root: true,
                  });
                }
                if (d?.msg === 'Missing Authorization Header') {
                  store.commit('user/setSigninPopup', true, {
                    root: true,
                  });
                }
              }
              if (response && !response.ok) {
                checkServerState();
                const locale = store.getters?.['user/getLocale'] || 'fr';
                const userMessage = resolveApiErrorMessage({
                  api,
                  error: d,
                  locale,
                });
                reject({
                  ...d,
                  status: response.status,
                  statusText: response.statusText,
                  api,
                  userMessage,
                });
              }
              resolve(d);
            })
            .catch(() => {
              checkServerState();
              reject(response);
              // reject({ if at some point we will need err.name
              //   status: response.status,
              //   statusText: response.statusText,
              //   url: response.url,
              //   body: response.body,
              //   bodyUsed: response.bodyUsed,
              //   headers: response.headers,
              //   ok: response.ok,
              //   redirected: response.redirected,
              //   type: response.type,
              //   err,
              // });
            });
        })
        .catch(async (err) => {
          checkServerState();
          if (recall >= 3 || err.status_code || err) {
            clearTimeout(timer);
            resolve({...NoResponseAPI, text: err});
          }
        });
    }),
  ]);
};

export const callOauthAPI = (
  method,
  api,
  data = {},
  useMainToken = false,
  timeout = 10,
  recall = 0,
  immediate = false,
) => {
  let timer = null;
  // eslint-disable-next-line no-param-reassign
  timeout = 0;
  recall = 0;

  return Promise.race([
    new Promise((resolve) => {
      if (timeout) {
        timer = setTimeout(async () => {
          let response = {error: 'Timeout'};
          if (recall < 3) {
            response = await callAPI(
              method,
              api,
              data,
              useMainToken,
              10,
              recall + 1,
            );
          }
          setTimeout(() => resolve(response));
        }, timeout * 1000);
      }
    }),
    new Promise((resolve) => {
      const headers = {
        'Content-Type': 'application/json; charset=utf-8',
      };
      const token = localStorage.getItem(FYGR_OAUTH_ACCESS_TOKEN);
      headers.Authorization = token ? `Bearer ${token}` : '';
      fetch(
        `${urlOauthBase}/${api}${method === 'GET' ? objectToParamString(data) : ''}`,
        {
          method,
          mode: 'cors',
          cache: 'no-cache',
          credentials: 'same-origin',
          headers,
          redirect: 'follow',
          referrer: 'no-referrer',
          body: method === 'GET' ? null : JSON.stringify(data),
        },
      )
        .then((response) => {
          clearTimeout(timer);
          if (immediate) {
            resolve(response);
            return;
          }
          response.json().then((d) => {
            if (d.error && d.status_code === 401) {
              window.open('/error', '_self');
            }
            resolve(d);
          });
        })
        .catch(async (err) => {
          if (recall >= 3 || err.status_code || err) {
            clearTimeout(timer);
            resolve({...NoResponseAPI, text: err});
          }
        });
    }),
  ]);
};

export default {};
